import { createSvgIcon } from "@mui/material";

const BankDialogIcon = createSvgIcon(
  <svg viewBox="0 0 80 80" fill="none">
    <path
      d="M0 21.3333C0 9.55126 9.55126 0 21.3333 0H58.6667C70.4487 0 80 9.55126 80 21.3333V58.6667C80 70.4487 70.4487 80 58.6667 80H21.3333C9.55126 80 0 70.4487 0 58.6667V21.3333Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M23 28.9836C23 28.072 23.6165 27.2757 24.4992 27.0474L43.242 22.1993C43.7469 22.0687 44.2772 22.072 44.7805 22.2088L62.5248 27.034C63.3956 27.2708 64 28.0614 64 28.9639V50C64 51.1046 63.1046 52 62 52H25C23.8954 52 23 51.1046 23 50V28.9836Z"
      fill="#E8EEF2"
    />
    <path d="M20 34C20 41.42 20 53 20 53" stroke="#B4C8D3" strokeWidth="3" strokeLinecap="round" />
    <path d="M56 34V53" stroke="#B4C8D3" strokeWidth="3" strokeLinecap="round" />
    <path d="M32 34V53" stroke="#B4C8D3" strokeWidth="3" strokeLinecap="round" />
    <path d="M44 34V53" stroke="#B4C8D3" strokeWidth="3" strokeLinecap="round" />
    <mask id="path-7-inside-1_171_11327" fill="white">
      <rect x="14" y="56" width="48" height="10" rx="2" />
    </mask>
    <rect
      x="14"
      y="56"
      width="48"
      height="10"
      rx="2"
      stroke="#B4C8D3"
      strokeWidth="6"
      mask="url(#path-7-inside-1_171_11327)"
    />
    <path
      d="M44.7444 29H17C15.8954 29 15 28.1046 15 27V25.374C15 24.5454 15.5108 23.8027 16.2845 23.5063L37.7584 15.28C38.2283 15.1 38.7489 15.1037 39.2162 15.2906L59.7424 23.4957C60.5019 23.7993 61 24.5348 61 25.3528V27C61 28.1046 60.1046 29 59 29H50.6241"
      stroke="#B4C8D3"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>,
  "BankDialogIcon"
);

export default BankDialogIcon;
